<template>
  <router-view v-if="!isLoading" />
</template>

<script setup>

import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router';
import { useAuth } from '@/shared/hooks/useAuth';
import { useRouteCheck } from '@/shared/hooks/useRouteCheck';
import { onBeforeMount, ref } from 'vue';
import { authRouteNames, privateRouteNames } from '@/router/routes';

const route = useRoute();
const router = useRouter();
const isLoading = ref(true);
const { isAuthenticated, authToken, getProfile, logout } = useAuth();
const { getDownloadRoute } = useRouteCheck();

onBeforeRouteUpdate((to) => {
  return !(privateRouteNames.includes(to.name) && !isAuthenticated.value) ||
    (authRouteNames.includes(to.name) && isAuthenticated.value);
});

onBeforeMount(async () => {
  if (!isAuthenticated.value && authToken.value) {
    try {
      await getProfile();
    } catch (e) {
      await logout();
    }
  }

  if (!isAuthenticated.value && privateRouteNames.includes(route.name)) {
    await logout();
  }

  if (isAuthenticated.value && authRouteNames.includes(route.name)) {
    router.replace(getDownloadRoute());
  }

  isLoading.value = false;
});

</script>